import { ofType } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { TransformResponse } from './transform';

import {
    SETSELECTED,
    NO_CHANGE,
    SET,
    RESET,
    SETSELECTED_NEXTGEN
} from 'one-state-subject/src/types';

import {
    setAction, reinitAction
} from 'one-state-emergencycontactnextgen/src/actions';
import {
    setAction as setSkeletonAction
} from 'one-state-skeleton';
import {
    Skeleton,
} from 'one-model-local';
import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import {format} from 'one-util-date';
import { Disposition } from 'one-model-local';
import { InvokeFinesseProxy } from '../../subject/src/index';

export const enum Types {
    SETEMERGENCYCONTACT = 'one-state-emergencycontactnextgen/set',
    STORE_DISPOSITION_CODE = "store-disposition-code",
}

const pushToSkeleton = (payload: any) => setSkeletonAction(payload);
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });

/**
 * This Function will fetch the data of Emergency Contact
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */
export const fetchEmergencyContactNextgen = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { server, log, agentId, teamName, alertnotification, settings: {
            nextgenendpoints: {
                getemergencycontact,
                apitoken
            },
            servers,
            uisettings: {
                dashboardapiconfig: {
                    getemergencycontact: getemergencycontactApi
                }
            },
            compatible: { consolidated_api_invocation, contact_center_type, finesse_proxy_service },
        } } = context;
        const { locations = [] } = servers;
        return action$.pipe(
            consolidated_api_invocation ? ofType(NO_CHANGE) : ofType(SETSELECTED_NEXTGEN),
            mergeMap((action: any) => {
                let dataresponse: any = action.payload;
                const getRequest = (datares: any) => {
                    if (datares?.id) {
                        let headers = new Headers();
                        headers.set('Authorization', 'Basic ' + apitoken?.token);
                        const data = {
                            "PatientID": datares.PatientID.toString(),
                            "PracticeID":datares.practiceId.toString()
                        }
                        let response;
                        if (finesse_proxy_service) {
                            response = InvokeFinesseProxy(getemergencycontact + "?PatientID=" + data.PatientID, "", apitoken, locations, log, 'POST', alertnotification);

                        } else {
                            response = server.post({
                                path: getemergencycontact,
                                data,
                                headers: headers
                            })
                                .then((responsefound: any) => responsefound)
                                .catch((responseresult: any) => {
                                    log.error(
                                        "ccw-gadget,emergencycontact-cerner",
                                        "fetch-EmergencyContact-cerner", {
                                        responseresult
                                    }
                                    );
                                    let errorbuild: ErrorObject = {
                                        source: "Emergency Contact",
                                        type: "error",
                                        status: responseresult?.status,
                                        erroritems: responseresult?.errors,
                                        error_date: errorDate,
                                        error_time: errorTime
                                    };
                                    return errorbuild;
                                })
                            log.debug(
                                "ccw-gadget,emergencycontact-cerner",
                                "fetch-EmergencyContact-cerner", {
                                response
                            }
                            );
                        }
                        return from(response)
                    } else {
                        return from([]);
                    }
                }
                if (!getemergencycontactApi) return []
                return getRequest(dataresponse).
                    pipe(
                        map((response: any) => TransformResponse(response, context))).
                    pipe(
                        flatMap(response => {
                            const actions: any = [];
                            
                            // Only add setAction if edata exists and is an array
                            if (response.edata && Array.isArray(response.edata)) {
                                actions.push(setAction(response.edata));
                            } else {
                                // If no data, set empty array
                                actions.push(setAction([]));
                            }
                            
                            if (response.error) {
                                actions.push(addAction(response.error));
                                let disp: Disposition = { value: "1003" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value?.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value?.choosecaller?.callId;
                                }
                                disp.meta02 = dataresponse.id;
                                disp.meta03 = response.error.status;
                                disp.meta04 = response.error.erroritems?.[0]?.error_detail;
                                disp.meta05 = 'client';
                                actions.push(pushToDisposition(disp));
                            } else {
                                let disp: Disposition = { value: "187" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value?.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName
                                    disp.dial_list_uid = state$.value?.choosecaller?.callId;
                                }
                                disp.meta02 = dataresponse.id;
                                disp.meta03 = '200';
                                disp.meta04 = 'client';
                                actions.push(pushToDisposition(disp));
                            }
                            // clear skeleton for emergency contact
                            let skeletonEmergencyContact: Skeleton = {
                                emergencycontact_skeleton: false
                            }
                            actions.push(pushToSkeleton(skeletonEmergencyContact));
                            return actions;
                        })
                    )
            })
        )
    }
);

export const clearEmergencyContactNextgen = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, patient-emergencycontactNextgen",
            "clear-EmergencyContact-Nextgen", {
        });
        return action$.pipe(
            ofType(SET, RESET),
            map(action => reinitAction())
        )

    }
); 